module.exports = __webpack_public_path__ + "img/ico_look_active.88aff058.svg";